import React, { forwardRef } from 'react';
import { BaseInput } from '../../inputs';

const SearchInput = forwardRef(({ value, onChange, onAdd }, ref) => {
  const handleChange = ({ target: { value } }) => {
    if (value.endsWith(',')) {
      const newItem = value.substring(0, value.length - 1);
      onAdd(newItem);
    } else {
      onChange(value);
    }
  };

  const handleAdd = () => onAdd(value);

  const handleKeyDown = (e) => {
    const key = e.key.toLowerCase();
    const keysToSearch = ['enter', 'tab'];

    if (keysToSearch.includes(key)) {
      e.preventDefault();
      onAdd(value);
    }
  };

  return (
    <BaseInput
      ref={ref}
      wrapperClass='wrapper-fill-column'
      type='text'
      placeholder='Search...'
      name='search'
      value={value}
      onChange={handleChange}
      quickAddClick={handleAdd}
      onKeyDown={handleKeyDown}
    />
  );
});

export default SearchInput;
